<template>
  <div :class="$style.field">
    <label :for="id">Call Summary</label>
    <textarea
      :id="id"
      v-model="value"
      rows="3"
      v-autosize
      placeholder="Write a summary and next steps here"
      :name="id"
      :autocomplete="id"></textarea>
    <p v-show="error && showError">{{error}}</p>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapMutations } = createNamespacedHelpers('activitySummary')

  export default {
    data () {
      return {
        id: 'summary',
        value: ''
      }
    },
    computed: {
      ...mapState([
        'activity',
        'formErrors',
        'formValues'
      ]),
      error () {
        return this.formErrors[this.id]
      }
    },
    watch: {
      value (value) {
        this.handleValue(value)
      }
    },
    created () {
      this.$_activitySummary_config.EventBus.$on('ACTIVITY_FORM_SUBMITTED', () => {
        this.showError = true
      })

      this.value === this.activity.summary
        ? this.handleValue(this.value)
        : this.value = this.activity.summary || ''
    },
    methods: {
      ...mapMutations(['upsertFormData']),
      handleValue (value) {
        this.showError = false
        this.upsertFormData({
          id: this.id,
          value
        })
      }
    }
  }
</script>

<style module lang="less" src="../custom-section/fields/field.less"></style>



// WEBPACK FOOTER //
// summary-input.vue?4e4b75ad